import { PoolInfo, PoolLocation, poolMaterialFactor } from "../context/types";

export const calculateHeatDemandOrLoss = ({
  poolInfo,
  surfaceHeatLoss,
  surfaceArea,
}: {
  poolInfo: PoolInfo;
  surfaceHeatLoss: number;
  surfaceArea: number;
}) => {
  if (poolInfo.poolMaterial) {
    const poolCoverFactor = poolInfo.withCover ? 0.5 : 1;
    const poolMaterial = poolMaterialFactor[poolInfo.poolMaterial];

    const sunRadiatorFactor = surfaceArea * 0.18;

    const poolLocation =
      poolInfo.location === PoolLocation.INDOOR ? 0 : sunRadiatorFactor;

    const formula: any =
      surfaceHeatLoss * poolCoverFactor +
      surfaceHeatLoss * 0.2 * poolMaterial -
      poolLocation;

    return formula * 0.6;
  } else {
    return 0;
  }
};
